const variantClasses = {
  default:  'bg-surface shadow-clay dark:shadow-clay-dark',
  bordered: 'bg-surface border border-surface shadow-clay dark:shadow-clay-dark',
  elevated: 'bg-surface shadow-clay-hover dark:shadow-clay-dark-hover',
  flat:     'bg-white/60 dark:bg-[#191919]',
};

function Card({ variant = 'default', className = '', children, ...props }) {
  return (
    <div
      className={[
        'rounded-clay overflow-hidden transition-shadow duration-200',
        variantClasses[variant],
        className,
      ].join(' ')}
      {...props}
    >
      {children}
    </div>
  );
}

Card.Header = function CardHeader({ className = '', children, ...props }) {
  return (
    <div
      className={[
        'px-5 py-4 border-b border-neutral-100 dark:border-transparent',
        className,
      ].join(' ')}
      {...props}
    >
      {children}
    </div>
  );
};

Card.Body = function CardBody({ className = '', children, ...props }) {
  return (
    <div className={['px-5 py-4', className].join(' ')} {...props}>
      {children}
    </div>
  );
};

Card.Footer = function CardFooter({ className = '', children, ...props }) {
  return (
    <div
      className={[
        'px-5 py-4 border-t border-neutral-100 dark:border-transparent bg-neutral-50/80 dark:bg-black/20',
        className,
      ].join(' ')}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
